export default function patrimonysubgroups(state = [], action) {
    switch (action.type) {
        case 'ADD_CURRENT':
            return {
                ...state,
                patrimonysubgroup: action.patrimonysubgroup,
            }
        default:
            return state;
    }
}
